import { getCurrentPlan } from 'conversations/modules/gates/selectors'
import { getCurrentUser } from 'conversations/modules/user/selectors'
import { getDesktopVersion, isRunningInDesktop } from 'conversations/utils/PlatformUtil'
import { Epic } from 'redux-observable'
import { empty } from 'rxjs'
import { filter, mergeMap, pluck } from 'rxjs/operators'
import { track, TrackEventPayload } from 'shared/store/actions/tracking'
import { isProduction } from 'shared/utils/environment'

import { isActionOf, RootAction, RootState } from 'typesafe-actions'

const SHOULD_SEND_TO_SEGMENT = isProduction

const sendTrackEvents = async (state: RootState, events: TrackEventPayload[]) => {
  const currentUser = getCurrentUser(state)
  if (currentUser === undefined) {
    return
  }

  const desktopVersion = await getDesktopVersion()

  events.forEach((event) => {
    if (SHOULD_SEND_TO_SEGMENT) {
      const trackEvent = {
        userId: currentUser.id,
        orgId: currentUser.orgId,
        email: currentUser.email,
        plan: getCurrentPlan(state),
        isDesktop: isRunningInDesktop,
        electronAppVersion: desktopVersion,
        ...event.properties,
      }
      window.analytics && window.analytics.track(event.name, trackEvent)
    } else {
      // eslint-disable-next-line
      console.debug('tracking:', event)
    }
  })
}

export const trackingEpic: Epic<RootAction, RootAction, RootState> = (action$, state) =>
  action$.pipe(
    filter(isActionOf(track)),
    pluck('payload'),
    mergeMap((payload) => {
      sendTrackEvents(state.value, [payload])
      return empty()
    })
  )
